import React, { useContext, useState, useEffect, useRef, useMemo } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";

//importing context consumer here
import { UserContext } from "../contexts/User";
import { getSystemSettings } from "../functions/Functions";
import { useCustomHooks } from "../functions/Hooks";
//context consumer
import { SettingsContext } from "../contexts/Settings";
import { RestaurantContext } from "../contexts/Restaurant";
//functions
import { _t, getCookie, getOffline } from "../functions/Functions";
import { BASE_URL } from "../BaseUrl";
import BellRing from "../resources/restaurant/auth/modal/BellRing";
import CustomSpinLoader from "../resources/components/CustomSpinLoader";

const checkAuthorization = () => {
  const userUrl = BASE_URL + "/auth/user";
  return getOffline(userUrl);
};
const PosOrderRoute = ({ children, ...rest }) => {

  //getting context values here
  let {
    generalSettings,
  } = useContext(SettingsContext);
 
  let { orderTypeList, bellRing, setBellRing, audioInstance, branchForListSearch } = useContext(RestaurantContext);

  const location = useLocation();

  //getting context values here
  const { authUserInfo } = useContext(UserContext);

  const { checkOnlineOrders, getFirbaseRunningOrder, intervalRef, getAutoAccOnlineOdr } = useCustomHooks()

  const [isAuthorized, setIsAuthorized] = useState(null); // null means loading

  const isOnlineOrderEnabled = useMemo(() => {
    return getSystemSettings(generalSettings, "online_order_status") === "1";
  }, [generalSettings]);

  // const determineOrderType = () => {
  //   if (window.location.pathname === "/dashboard/pos/online-orders") {
  //     return "online";
  //   }
  //   if (window.location.pathname === "/dashboard/pos/foodpanda") {
  //     return "fp";
  //   }
  //   return "";
  // };

  //close bell ring
  const handleBellRingClose = () =>{
    setBellRing(false);
    if(audioInstance.current){
      audioInstance.current.pause();
      audioInstance.current.currentTime = 0;
    }
  }

  const canTakeOnlineOrder = useMemo(() => {
    if (!orderTypeList?.data || !authUserInfo?.details) return false;
    const userOrderTypes =
      authUserInfo.details.order_type_id &&
      JSON.parse(authUserInfo.details.order_type_id || "[]");
    return orderTypeList.data.some((orderType) => {
      const isDeliveryOrTakeaway =
        orderType.name.toLowerCase() === "delivery" ||
        orderType.name.toLowerCase() === "takeaway";
  
      const isOrderTypeActive = orderType.status === "On";
  
      if (userOrderTypes?.length > 0) {
        return (
          isOrderTypeActive &&
          isDeliveryOrTakeaway &&
          userOrderTypes.includes(orderType.id)
        );
      }
  
      return isOrderTypeActive && isDeliveryOrTakeaway;
    });
  }, [orderTypeList?.data, authUserInfo?.details]);

  useEffect(()=>{
    const fetchAuthorization = async () => {
      const authorizedUser = await checkAuthorization();
      setIsAuthorized(authorizedUser);
    };
    fetchAuthorization();
    return () => {
      setTimeout(() => {
        handleBellRingClose();
      }, 5000);
    };
  },[])

  useEffect(() => {
    let runningOrdersUnsubscribe;
    let onlineOrdersUnsubscribe;

    if (generalSettings && authUserInfo?.details && authUserInfo.details.user_type !== "call_center") {
      // 1. Listen for submitted/running orders
      runningOrdersUnsubscribe = getFirbaseRunningOrder();
      
      // 2. Listen for online orders
      if (isOnlineOrderEnabled && canTakeOnlineOrder) {
        onlineOrdersUnsubscribe = checkOnlineOrders();
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      if (typeof onlineOrdersUnsubscribe === "function") onlineOrdersUnsubscribe();
      if (typeof runningOrdersUnsubscribe === "function") runningOrdersUnsubscribe();
    };
  }, [
    canTakeOnlineOrder, 
    isOnlineOrderEnabled
  ]);

  useEffect(()=>{
    if (!branchForListSearch || !authUserInfo?.details?.branch_id) return;
    if(branchForListSearch[authUserInfo.details.branch_id]?.auto_accept){
      const unsubscribe = getAutoAccOnlineOdr();
      return () => {
        if (typeof unsubscribe === "function") {
          unsubscribe && unsubscribe();
        }
      };
    }

  },[branchForListSearch, authUserInfo?.details])

  // loading if until user authentication
  if(getCookie() === undefined && isAuthorized === null){
    return(
      <>
        <CustomSpinLoader loading={true}/>
        <Route
          {...rest}
          render={()=>children}
        ></Route>
      </>
    )
  }

  //redirect if customer
  if (authUserInfo.details && authUserInfo.details.user_type === "customer") {
    return (
      <Route
        render={() => {
          return (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          );
        }}
      ></Route>
    );
  }
   
  return (
    <Route
      {...rest}
      render={() => {
        return (getCookie() !== undefined || isAuthorized) ? (
          <>
           <BellRing bellRing={bellRing} handleBellRingClose={handleBellRingClose} type="primary"/>
           {children}
          </>
        ) : (
          <Redirect
            to={{
              pathname: "/",
              state: { alert: "You need to login first!" },
            }}
          />
        );
      }}
    ></Route>
  );
};
export default PosOrderRoute;
